<template>
	<Tickets userType="agent" />
</template>

<script>

	export default {
		name: 'AgentTicketView',
		components: {
			'Tickets': () => import('@/components/ticket/Tickets.vue'),
		},
		data() {
			return {

			}
		}
	}
</script>
<style></style>
